export default "__VITE_ASSET__B$HDqbCc__"